import * as React from 'react';
import {createFileRoute, useRouter} from '@tanstack/react-router';
import {getSavedQuotes} from '@/services.ts';
import type {SystemQuote} from '@/types';
import {ViewSystem} from '@/components/molecules/ViewSystem.tsx';
import {queryOptions, useSuspenseQuery} from '@tanstack/react-query';
import {ACCOUNT_STALE_TIME_5_MINS} from '@/config';
import {LoadingScreen} from '@/components/molecules/LoadingScreen.tsx';
import {ShowAsDollars} from '@/components/atoms/ShowNumberAsDollars.tsx';
import {ShowDate} from '@/components/atoms/ShowDate.tsx';
import { ErrorComponent } from '@/components/molecules/ErrorComponent';
import { Card, CardContent } from '@/components/atoms/card';

const savedQuotesQueryOptions = (isServer: boolean) => queryOptions({
  queryKey: ['account', 'saved-quotes'],
  queryFn: async () => {
    if(isServer) {
      return null;
    }
    return getSavedQuotes();
  },
  retry: false,
  staleTime: ACCOUNT_STALE_TIME_5_MINS,
});

export const Route = createFileRoute('/account/saved-quotes')({
  loader: async({ context }) => {
    return context.queryClient?.ensureQueryData(savedQuotesQueryOptions(context.isServer));
  },
  pendingComponent: LoadingScreen,
  component: SavedQuotes,
  errorComponent: ErrorComponent,
});

function SavedQuotes() {
  const [viewQuoteIsOpen, setViewQuoteIsOpen] = React.useState(false);
  const [systemQuote, setSystemQuote] = React.useState<SystemQuote | null>(null);
  const router = useRouter();
  const { error, data } = useSuspenseQuery(savedQuotesQueryOptions(router.isServer));

  const handleViewQuote = (quote: SystemQuote) => () => {
    setSystemQuote(quote);
    setViewQuoteIsOpen(true);
  }

  if(error) {
    console.log(error);
    console.log('-------------------------------- IIII');
    return (<ErrorComponent error={error} />)
  }
  console.log(data);
  console.log('-------------------------------- IIII---');
  if(data) {
    return(
      <div className="space-y-4 mt-8">
        <ViewSystem isOpen={viewQuoteIsOpen} onOpenChange={setViewQuoteIsOpen} system={systemQuote} />
        <h1 className="text-4xl">Saved Quotes</h1>
        {
          data.map((quote: SystemQuote) => (
            <Card key={`__quote__${quote._id}__`} className="w-full">
                <CardContent onClick={handleViewQuote(quote)}>
                <div className="flex flex-col gap-2">
                  <div className="flex justify-between items-center">
                    <h3 className="text-lg font-bold">{quote.name}</h3>
                    <ShowDate date={quote.quoteDate} />
                  </div>
                  <div className="flex justify-between items-center">
                    <div>
                      <div className="text-muted-foreground">Quote No</div>
                      <div>
                        {quote.quoteNo}
                      </div>
                    </div>
                    <div>
                    <div className="text-muted-foreground">Quote Total</div>
                    <div>
                      <ShowAsDollars number={quote.quoteTotal} />
                    </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))
        }
      </div>
    )
  }
}
